<script lang="ts">
    import ImagePreviewRow from "../widgets/TaskImages/ImagePreviewRow.svelte"
    import { getCachedEntries } from "../../../api"
    import ImageFieldLibrary from "../widgets/TaskImages/ImageFieldLibrary.svelte"
    import ImagesUpload from "./ImageUpload/ImagesUpload.svelte"

    export let field: TaskStepField<"image[]">, value: string[]
    //

    let imagesData: Media[]
    let loading = true
    if (value?.length > 0) {
        getCachedEntries("media", {
            _id: {
                $in: value,
            },
        }).then((res) => {
            imagesData = res
            loading = false
        })
    } else {
        imagesData = []
        loading = false
    }
    let modalStates = {
        showImageUploadModal: false,
    }

    const handleImageClick = () => {
        modalStates.showImageUploadModal = true
    }
    $: {
        const newValues = imagesData?.map((image) => image.id)
        if (JSON.stringify(newValues) !== JSON.stringify(value) && !loading) {
            if (newValues.length == 0 && !value) {
            } else value = newValues
        }
    }

    let showFileLibrary = false
    let reopenImageLibrary = false
    $: if (!modalStates.showImageUploadModal && reopenImageLibrary && noModalVisible) {
        reopenImageLibrary = false
        showFileLibrary = true
    }
    let noModalVisible = false
    const taskId = document.location.pathname.split("/").pop().split("?")[0]
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="image-row {imagesData?.length == 0 ? 'smallOne' : ''}"
    on:click="{() => {
        if (imagesData?.length == 0) handleImageClick()
    }}"
>
    <h3
        class="label"
        style="{imagesData?.length > 0 ? 'padding-bottom: 6px;' : ''}"
    >
        <img
            src="../../../assets/icons/solar_camera-outline.svg"
            alt="icon"
        />
        <p>FOTOS</p>
    </h3>
    {#if imagesData?.length === 0}
        <button class="editImages">
            <img
                src="../../../assets/icons/solar_album-outline.svg"
                alt="icon"
            />
        </button>
    {:else}
        <ImagePreviewRow
            imageData="{imagesData}"
            on:uploadImage="{handleImageClick}"
            on:openImageModal="{() => {
                showFileLibrary = true
            }}"
        />
    {/if}
</div>
{#if showFileLibrary}
    <ImageFieldLibrary
        bind:images="{imagesData}"
        on:removeImage="{(e) => {
            imagesData = imagesData?.filter((image) => image.id !== e.detail)
        }}"
        on:closeImageLibrary="{() => {
            showFileLibrary = false
        }}"
        on:uploadImage="{() => {
            showFileLibrary = false
            reopenImageLibrary = true
            handleImageClick()
        }}"
    />
{/if}

{#if imagesData}
    <ImagesUpload
        bind:imagesData="{imagesData}"
        bind:showImageUploadModal="{modalStates.showImageUploadModal}"
        taskId="{taskId}"
    />
{/if}

<style lang="less">
    .image-row {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        padding: 0.6rem;
        border-radius: 12px;
        border: 1px solid var(--grey-200);
        background: var(--white-100);
        &.smallOne {
            flex-direction: row;
            justify-content: space-between;
            padding: 0px 0.6rem;
            cursor: pointer;
            .label {
                min-height: 54px;
            }
        }
    }
    h3.label {
        display: flex;
        gap: 0.6rem;
        align-items: center;
    }

    :global .modalMap {
        width: 100%;
        .mapwrapper {
            height: 400px !important;
            width: 100%;
        }
    }
</style>
